import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Currency from './currency';

export function CommissionAmount({ deal }) {
  return (
    <Currency
      label="Commission $"
      name="grossCommission"
      value={deal.grossCommissionAmount}
    />
  );
}

CommissionAmount.propTypes = {
  deal: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
});

export default connect(mapStateToProps)(CommissionAmount);
